export default __webpack_public_path__ + "static/7-9b839f9460f52568d5aa2ac37589ebb5.jpg";